import { render } from "./SubscriptionTierSelection.vue?vue&type=template&id=65ba72bf&scoped=true"
import script from "./SubscriptionTierSelection.vue?vue&type=script&lang=js"
export * from "./SubscriptionTierSelection.vue?vue&type=script&lang=js"

import "./SubscriptionTierSelection.vue?vue&type=style&index=0&id=65ba72bf&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ba72bf"]])

export default __exports__